export const AMERICAN_WHIRLPOOL = 'American Whirlpool';
export const VITA_SPAS = 'Vita Spas';
export const BULL_BBQS = 'Bull BBQs';
export const VIKING_SPAS = 'Viking Spas';